import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Platform }         from 'ionic-angular';
import { AngularFire, AuthProviders,
    AuthMethods} from 'angularfire2';
import firebase from 'firebase';
import {FaceBookService}        from './facebook-provider';

declare var window: any;

@Injectable()
export class FirebaseService {
    userStatus: any = {};
    constructor(
        public http: Http,
        private platform: Platform,
        public af: AngularFire,
        private faceBookService: FaceBookService
    ) {
        var that = this;
        this.af.auth.subscribe(user => {
            if (user == null) return;
            console.log(user);
            that.userStatus = user;
        });
    }
    logout() {
        this.af.auth.logout();
    }
    login(method,usernmae="",userpassword="") {
        switch (method) {
            case 'facebook':
                this.faceBookService.login();
                break;
            case 'google':
                this.af.auth.login({
                    provider: AuthProviders.Google,
                    method: AuthMethods.Redirect});
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/feature/loginModule/providers/firebase-provider.ts